import { render, staticRenderFns } from "./ViewOrderHistory.vue?vue&type=template&id=c2825718"
import script from "./ViewOrderHistory.vue?vue&type=script&lang=js"
export * from "./ViewOrderHistory.vue?vue&type=script&lang=js"
import style0 from "./ViewOrderHistory.vue?vue&type=style&index=0&id=c2825718&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2825718')) {
      api.createRecord('c2825718', component.options)
    } else {
      api.reload('c2825718', component.options)
    }
    module.hot.accept("./ViewOrderHistory.vue?vue&type=template&id=c2825718", function () {
      api.rerender('c2825718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ViewOrderHistory.vue"
export default component.exports